export const SENTRY_RELEASE: string | undefined = '34c3b7f412f2cf66770927c6e0f3ed8defd01642';
